import * as React from 'react';
export const retoolSvg = React.forwardRef(function retoolSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F5F5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.5 7.425A1.925 1.925 0 0 1 7.425 5.5h7.525a1.925 1.925 0 0 1 1.925 1.925v1.487a.963.963 0 0 1-.963.963h-9.45a.963.963 0 0 1-.962-.963V7.425Zm0 6.038a.962.962 0 0 1 .963-.963h18.112a1.925 1.925 0 0 1 1.925 1.925v4.988a.962.962 0 0 1-.962.962H7.425A1.925 1.925 0 0 1 5.5 18.45v-4.987Zm9.625 10.5a.962.962 0 0 1 .962-.963h9.45a.962.962 0 0 1 .963.962v.613a1.925 1.925 0 0 1-1.925 1.925H17.05a1.925 1.925 0 0 1-1.925-1.925v-.613Z',
      fill: '#262626',
    }),
  );
});
retoolSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var retool = {
  category: 'brand',
  colorable: false,
  name: 'retool',
  svg: retoolSvg,
};
